var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "col-12 px-0 h-100" }, [
    _c("img", {
      staticClass: "picto-add",
      attrs: { alt: "", src: _vm.iconPlus },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "container mw-100 border-gray div-img h-100 recommended-internet-tile mb-0",
      },
      [
        _c("div", { staticClass: "row h-100 px-0" }, [
          _c("div", { staticClass: "col-12 px-0" }, [
            _c("div", { staticClass: "row px-1" }, [
              _c("section", { staticClass: "pb-2" }, [
                _vm.offer.banner
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "row align-items-center reco-banner" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-auto p-0 padding-bottom-banner",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ob1-tag ob1-tag-primary" },
                                [_c("span", [_vm._v(_vm._s(_vm.offer.banner))])]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.offer.timerEndDateInMilliseconds
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-auto p-0 padding-left-tag padding-bottom-banner",
                                },
                                [
                                  _c("timer", {
                                    attrs: {
                                      "end-date-in-milliseconds":
                                        _vm.offer.timerEndDateInMilliseconds,
                                      color: _vm.offer.countDownColor
                                        ? _vm.offer.countDownColor
                                        : "text-dark",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ])
                  : _c("div", { staticClass: "col-12 reco-banner" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 pb-1 text-center" }, [
                _c(
                  "div",
                  { staticClass: "reco-title text-primary pb-0 mb-0" },
                  [
                    _c("h2", { staticClass: "h4" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.offer.name) +
                          "\n                            "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 pb-2 d-flex justify-content-center" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "ob1-link-arrow",
                      attrs: {
                        href: _vm.offer.foLink,
                        "data-oevent-category":
                          _vm.offer.foHighlightTms.category,
                        "data-oevent-action": _vm.offer.foHighlightTms.action,
                        "data-oevent-label": _vm.offer.foHighlightTms.label,
                      },
                    },
                    [_vm._v(_vm._s(_vm.offer.foLinkLabel))]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 pt-1 text-center" },
                [
                  _c("Price", {
                    attrs: {
                      custom: "reco-ob1-price h3 text-dark",
                      price: _vm.offer.price.price,
                      "initial-price": _vm.offer.price.initialPrice,
                      "price-details": _vm.offer.price.priceDetails
                        ? _vm.offer.price.priceDetails
                        : undefined,
                      "show-from": _vm.offer.price.showFrom,
                      "show-by-month": _vm.offer.price.showByMonth,
                      "show-promo-duration": _vm.offer.price.showPromoDuration,
                      duration: _vm.offer.price.duration,
                      "is-cents-format": false,
                      "is-mini": _vm.offer.price.mini,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 pb-2 text-center" }, [
                _c("strong", [_vm._v(_vm._s(_vm.offer.commitment))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 text-center px-0",
                  class: _vm.offerClaimsClass,
                },
                [
                  _c("div", { staticClass: "reco-claim" }, [
                    _vm.firstClaimWithImage
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "py-1 px-1",
                              class: _vm.offer.claimBgColor,
                            },
                            [
                              _c("div", [
                                _c("img", {
                                  staticClass: "reco-internet-claim-img",
                                  attrs: {
                                    loading: "lazy",
                                    src: _vm.firstClaimWithImage.image.url,
                                    alt: _vm.firstClaimWithImage.image.alt,
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.firstClaimWithImage.attributes,
                                function (attribute) {
                                  return _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mb-0 px-2 d-flex align-items-center justify-content-center",
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              attribute.textHtml
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 py-0 text-center" }, [
      _c("hr", { staticClass: "separator separator--gray4 my-0" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }